import * as React from 'react';
import S from './Breadcrumb.styles';
const Breadcrumb = ({ items }) => {
    if (!items) {
        return null;
    }
    return (React.createElement(S.Container, null, items.map((item, i) => (React.createElement(S.Item, { key: `breadcrumb-${i}` }, i !== items.length - 1 ? (React.createElement(React.Fragment, null,
        React.createElement(S.ItemLink, { href: item.url }, item.name),
        "/")) : (React.createElement(S.CurrentItem, null, item.name)))))));
};
export default Breadcrumb;
